import React from 'react';
import styled from 'styled-components';
import { Captions, ShortBody } from 'components/Typography';
import { Accordion, AccordionDetails, Grid, Tooltip } from '@material-ui/core';

export const StyledValidAccordion = styled(({ color, ...otherProps }) => (
  <Accordion {...otherProps} />
))`
  border-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
`;
export const StyledCaption = styled(Captions)`
  && {
    color: #838ea4;
    font-size: 13px !important;
    line-height: 18px !important;
    margin: 0;
  }
`;
export const StyledShortBody = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  && {
    font-weight: 500;
    font-size: 17px !important;
    line-height: 20px !important;
    text-align: ${(props) => (props.reverse ? 'right' : 'left')}!important;
  }
`;
export const StyledLink = styled.a`
  && {
    text-decoration: none;
  }
`;

export const AlignedGrid = styled(Grid)`
  align-self: center;
`;

export const SizedGrid = styled(Grid)`
  min-height: 200px;
`;
export const formStyle = {
  infoIcon: {
    cursor: 'pointer',
    height: '20px',
    width: '20px',
    color: '#C2D1D9',
    '&:hover': {
      borderRadius: '50%',
    },
  },
  infoIconDetails: {
    cursor: 'pointer',
    height: '17px',
    width: '17px',
    marginTop: '20px',
    color: '#C2D1D9',
    '&:hover': {
      borderRadius: '50%',
    },
  },
  infoIconPreDetails: {
    cursor: 'pointer',
    height: '17px',
    width: '17px',
    marginTop: '2px',
    marginLeft: '5px',
    marginRight: '5px',
    color: '#C2D1D9',
    '&:hover': {
      borderRadius: '50%',
    },
  },
};
export const StyledGridLeft = styled(Grid)`
  margin-left: 3px;
  margin-top: 1px;
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 4px;
  margin-top: -2px;
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  && {
    background-color: #f2f2f2;
  }
`;
export const ColoredDivider = styled.hr`
  && {
    height: 0px;
    border-top: 0.7px dashed #c0c5cf;
    opacity: 0.5;
    width: 95%;
  }
`;
export const StyledGridBottom = styled(Grid)`
  margin-bottom: 5px !important;
`;
export const StyledCaptions = styled(Captions)`
  && {
    color: #838ea4;
    font-size: 13px !important;
    line-height: 18px !important;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
`;

export const StyledInlineGrid = styled(Grid)`
  &&& {
    display: inline-flex;
  }
`;
